import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import AccountGroupMap from "../AdminScreenHeader/UserToChannel";
import Header from "../HomeScreenHeader/HomeHeader/Header.jsx";
import ConfigurationSpliter from "../AdminScreenHeader/ConfigurationSpliter.jsx";
import TVAPPConfig from "../AdminScreenHeader/TVAPPConfig.jsx";

export default function AdminScreenTabPanel({ onTabChange }) {
  const [activeIndex, setActiveIndex] = useState(0); // Default to "User To Channel"

  const handleTabChange = (e) => {
    setActiveIndex(e.index);
    if (onTabChange) onTabChange(e.index);
  };
  return (
    <>
      <Header />
      <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
        <TabPanel header="User To Channel" leftIcon="pi pi-user">
          <AccountGroupMap />
        </TabPanel>
        <TabPanel header="Configuration" leftIcon="pi pi-spin pi-cog">
          <ConfigurationSpliter />
        </TabPanel>
        <TabPanel header="Tv App" leftIcon="fa fa-television">
          <TVAPPConfig />
        </TabPanel>
      </TabView>
    </>
  );
}
